import React, { useState, useEffect } from "react"
import Recaptcha from "react-invisible-recaptcha"
import styled from "styled-components"
import { colors, breakpoints } from "utils/utils"

let recaptcha = ""
let textFields = {}
let disclaimers = {}
export default props => {
  const [errorMessage, setErrorMessage] = useState(false)
  const [successMessage, setSuccessMessage] = useState(false)
  const [confirmationEmailError, setConfirmationEmailError] = useState(false)

  const RECAPTCHA_KEY = process.env.SITE_RECAPTCHA_KEY

  const { form, lang, title, description } = props

  const encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  useEffect(() => {
    const checkField = elem => {
      if (!elem.classList.contains("hidden") && elem.required) {
        if (elem.type !== "checkbox" && elem.value === "") {
          if (lang === "en") {
            elem.setCustomValidity("Please fill out this field")
          } else {
            elem.setCustomValidity("Completa este campo")
          }
        } else if (elem.type === "checkbox" && !elem.checked) {
          if (lang === "en") {
            elem.setCustomValidity(
              "Please check this box if you want to proceed"
            )
          } else {
            elem.setCustomValidity("Marque esta casilla si desea continuar")
          }
        } else if (!elem.validity.valid && elem.type === "email") {
          if (lang === "en") {
            elem.setCustomValidity("Wrong email format")
          } else {
            elem.setCustomValidity("Formato de email incorrecto")
          }
        } else {
          elem.setCustomValidity("")
        }
      }
    }

    let inputs = document.querySelectorAll("form input")

    inputs.forEach(input => {
      input.addEventListener("invalid", e => checkField(e.target))
      input.addEventListener("input", e => e.target.setCustomValidity(""))
    })

    return () => {
      inputs.forEach(input => {
        input.removeEventListener("invalid", e => checkField(e.target))
        input.removeEventListener("input", e => e.target.setCustomValidity(""))
      })
    }
  }, [lang])

  const checkEmailFormat = elem => {
    if (!elem.validity.valid && elem.value !== "") {
      if (lang === "en") {
        elem.setCustomValidity("Wrong email format")
      } else {
        elem.setCustomValidity("Formato de email incorrecto")
      }
    }
  }

  const checkConfirmationEmail = () => {
    const email = document.getElementById("fnewsletter-email").value
    const cemail = document.getElementById("fnewsletter-cemail").value
    if (email !== cemail) {
      if (lang === "en") {
        setConfirmationEmailError(
          "The Confirmation Email must match your Email Address"
        )
      } else {
        setConfirmationEmailError(
          "El Email de confirmación debe coincidir con su Email"
        )
      }
      return false
    } else {
      return true
    }
  }

  const checkCustomerName = e => {
    const customerName = e.target.value.trim()
    if (customerName === "" && e.charCode === 32) {
      e.preventDefault()
    } else {
      handleTextFieldChange(e)
    }
  }

  const handleFormSubmit = e => {
    e.preventDefault()
    if (checkConfirmationEmail()) {
      setConfirmationEmailError("")
      recaptcha.execute()
    }
  }

  const handleTextFieldChange = e => {
    let tempObj = { ...textFields }
    tempObj[`${e.target.name}`] = e.target.value.trim()
    textFields = { ...tempObj }
  }

  const handleCheckboxChange = e => {
    let tempObj = { ...disclaimers }
    tempObj[`${e.target.id}`] = e.target.checked
    disclaimers = { ...tempObj }
  }

  const onRecaptchaResolved = () => {
    const path = window && window.location ? window.location.pathname : "/"
    fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "fnewsletter",
        "g-recaptcha-response": recaptcha.getResponse(),
        ...textFields,
        ...disclaimers,
      }),
    })
      .then(() => {
        setSuccessMessage(form.successMessage)
      })
      .catch(error => {
        console.warn(error)
        setErrorMessage(form.errorMessage)
      })
  }

  return (
    <NewsletterBlock>
      <TitleBlock>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TitleBlock>
      {!errorMessage && !successMessage ? (
        <Form
          name="fnewsletter"
          method="post"
          action="/"
          data-netlify="true"
          data-netlify-honeypot="field-bot-detection"
          data-netlify-recaptcha="true"
          onSubmit={handleFormSubmit}
        >
          <input type="hidden" name="form-name" value="fnewsletter" />
          <input
            name="field-bot-detection"
            onChange={handleTextFieldChange}
            className="hidden"
          />
          <InputsGroup>
            {form.formTextField &&
              form.formTextField.map((textfield, index) => (
                <InputBlock key={index}>
                  <Input
                    type={textfield.type}
                    id={`fnewsletter-${textfield.htmlid}`}
                    name={`fnewsletter-${textfield.htmlid}`}
                    onKeyDown={e =>
                      textfield.type === "email" && checkEmailFormat(e.target)
                    }
                    onKeyUp={e =>
                      textfield.type === "email" && checkEmailFormat(e.target)
                    }
                    onKeyPress={
                      textfield.type === "text" ? checkCustomerName : null
                    }
                    onChange={
                      textfield.type === "email" ? handleTextFieldChange : null
                    }
                    required={textfield.required}
                    placeholder={`${textfield.label} ${textfield.required &&
                      "*"}`}
                  />
                </InputBlock>
              ))}
          </InputsGroup>
          {confirmationEmailError && (
            <ConfirmEmailError>{confirmationEmailError}</ConfirmEmailError>
          )}
          {form.disclaimer &&
            form.disclaimer.map((disclaimer, index) => (
              <Disclaimer key={index}>
                <Checkbox
                  type="checkbox"
                  id={`fnewsletter-${disclaimer.htmlid}`}
                  name={`fnewsletter-${disclaimer.htmlid}`}
                  value={disclaimer.htmlid}
                  onChange={handleCheckboxChange}
                  required={disclaimer.required}
                />
                <CheckboxLabel htmlFor={`fnewsletter-${disclaimer.htmlid}`}>
                  {disclaimer.text.text}
                </CheckboxLabel>
              </Disclaimer>
            ))}
          <FormCTActions>
            <Recaptcha
              ref={ref => (recaptcha = ref)}
              sitekey={RECAPTCHA_KEY}
              onResolved={onRecaptchaResolved}
              locale={lang}
              badge="inline"
            />
            <Button
              id="fnewsletter-submitForm"
              name="fnewsletter-submitForm"
              type="submit"
            >
              {form.button}
            </Button>
          </FormCTActions>
        </Form>
      ) : errorMessage ? (
        <ErrorMessage>{errorMessage}</ErrorMessage>
      ) : (
        <SuccessMessage>{successMessage}</SuccessMessage>
      )}
    </NewsletterBlock>
  )
}

const ConfirmEmailError = styled.span`
  color: red;
  padding: 0.2rem 0;
  text-align: center;
  display: block;
  margin: auto;
  font-size: 0.7rem;
`

const NewsletterBlock = styled.div`
  width: 100%;
  background-color: ${colors.primary};
  color: ${colors.quinary};
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;

  ${breakpoints.md} {
    flex-direction: column;
  }
`

const TitleBlock = styled.div`
  align-self: center;
  width: 30%;
  ${breakpoints.md} {
    width: 100%;
    text-align: center;
  }
`

const Title = styled.h2`
  text-decoration: underline;
`

const Description = styled.p``

const Form = styled.form`
  align-self: center;
`

const InputBlock = styled.div`
  ${breakpoints.sm} {
    align-self: center;
  }
`

const InputsGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  ${breakpoints.sm} {
    flex-direction: column;
  }
`

const Input = styled.input`
  padding: 0.5rem;
  ${breakpoints.sm} {
    width: 100%;
    min-width: 50vw;
    max-width: 75vw;
  }
`

const Disclaimer = styled.div`
  margin: 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const Checkbox = styled.input`
  margin-right: 0.5rem;
  align-self: center;
`

const CheckboxLabel = styled.label`
  align-self: center;
`

const FormCTActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  ${breakpoints.sm} {
    flex-direction: column-reverse;
    > * {
      align-self: center;
    }
  }
`

const Button = styled.button`
  display: block;
  padding: 1rem 2rem;
  border: 0;
  border-radius: 0.2rem;
  background-color: ${colors.secondary};
  color: ${colors.quinary};
  width: min-content;
  cursor: pointer;
  ${breakpoints.sm} {
    margin: 0.5rem 0 1rem;
  }
`

const ErrorMessage = styled.span`
  align-self: center;
`

const SuccessMessage = styled.span`
  align-self: center;
`
